import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { publicApi } from "../../../api/axiosConfig";
import LandingUI from "./LandingUI";
import { saveCatalog } from "../../../storage/catalogStorage";


export default function Landing() {
  const [products, setProducts] = useState([]);


  const [newestProducts, setNewestProducts] = useState([]);
  const [popularProducts, setPopularProducts] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const PAGE_SIZE = 12;

  const [searchParams, setSearchParams] = useSearchParams();

  // Extract query params
  const page = parseInt(searchParams.get("page") || "1", 10);
  const searchQuery = searchParams.get("search") || "";

  const fetchProducts = async () => {
    try {
      setLoading(true);
      setError("");

      const params = {
        page,
        page_size: PAGE_SIZE,
        search: searchQuery || undefined,
      };

      // Fetch main list, newest, and popular products in parallel
      const [mainRes, newestRes, popularRes] = await Promise.all([
        publicApi.get("/api/v1/products/", { params }),
        publicApi.get("/api/v1/products/", {
          params: { ordering: "-created_at", page_size: 8 },
        }),
        publicApi.get("/api/v1/products/", {
          params: { ordering: "popular", page_size: 8 },
        }),
      ]);

      const data = mainRes.data;

      setProducts(data.results || []);
      setNewestProducts(newestRes.data?.results || []);
      setPopularProducts(popularRes.data?.results || []);

      setPageCount(
        Math.ceil((data.count || data.results?.length || 0) / PAGE_SIZE),
      );

      await saveCatalog(data);
    } catch (err) {
      console.error("Failed to load products:", err);

      setProducts([]);
      setPageCount(0);
      setError("اطلاعات محصولات در دسترس نیست.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "فروشگاه اینترنتی زومیو";
  }, []);

  useEffect(() => {
    // Fetch products whenever query filters change
    fetchProducts();
  }, [page, searchQuery]);

  // Unified function to sync filters with URL query params
  const applyFilters = (newFilters, resetPage = false) => {
    const currentParams = Object.fromEntries(searchParams.entries());
    const updatedParams = { ...currentParams, ...newFilters };

    if (resetPage) {
      updatedParams.page = "1";
    }

    Object.keys(updatedParams).forEach((key) => {
      if (
        updatedParams[key] === "" ||
        updatedParams[key] === false ||
        updatedParams[key] === undefined ||
        updatedParams[key] === null
      ) {
        delete updatedParams[key];
      }
    });

    setSearchParams(updatedParams);
  };

  const handlePageChange = (event, value) => {
    applyFilters({ page: value.toString() }, false);
  };

  return (
    <LandingUI
      products={products}
      newestProducts={newestProducts}
      popularProducts={popularProducts}
      loading={loading}
      error={error}
      page={page}
      count={pageCount}
      onPageChange={handlePageChange}
    />
  );
}
